import { FC, useEffect, useState } from "react";
import Form from "../Form";
import { useDispatch, useSelector } from "react-redux";
import { growthSelector, userSelector } from "../../redux/selectors";
import { setGrowth } from "../../redux/actions/growth";
import { growthQuestions } from "../../utils/constants";

const Growth: FC<any> = (props) => {
  const { validateForm = false } = props;
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const { growth } = useSelector(growthSelector);
  const { user } = useSelector(userSelector);

  const handleChange = (formData: any, isValid: boolean) => {
    dispatch(
      setGrowth({
        ...growth,
        formData: { ...growth.formData, ...formData, userId: user.id },
        isConfigured: isValid,
      })
    );
  };

  useEffect(() => {
    if (!growth.isConfigured && validateForm) {
      setError("You need to select atleast one preference from each section");
    } else {
      setError("");
    }
  }, [growth.isConfigured, validateForm]);

  return (
    <>
      <Form
        id="growth"
        questions={growthQuestions}
        handleChange={handleChange}
        formData={growth.formData}
      />
      <p className="form-error-message">{error}</p>
    </>
  );
};

export default Growth;
